import { InjectionToken } from '@angular/core';
import { HomePageContent } from '@epicuro-next/data/merchandise';
import { IConfigurations } from '@epicuro-next/platform/configuration';

export const FEATURE_NAME = 'home';

/**
 * configuration keys for this module
 */
export enum HomeConfigurationKeys {
  MobileHomePage = 'mobile-home-page',
  FilterBasedLandingPage = 'filter-based-landing-page',
  FilterBasedBanner = 'filter-based-banner',
  FilterBasedHomeDecider = 'filter-based-home-decider',
  MerchandisingDynamicPanelConfigs = 'merchandising-dynamic-panel-configs',
}

/**
 * Configuration return types and default values for this module
 */
export interface HomeConfigurations
  extends IConfigurations<HomeConfigurationKeys> {
  [HomeConfigurationKeys.MobileHomePage]: HomePageContent;
  [HomeConfigurationKeys.FilterBasedLandingPage]: string;
  [HomeConfigurationKeys.FilterBasedHomeDecider]: string;
  [HomeConfigurationKeys.FilterBasedBanner]: string;
  [HomeConfigurationKeys.MerchandisingDynamicPanelConfigs]: string;
}

export const HOME_META_REDUCER_TOKEN = new InjectionToken(
  'HOME_META_REDUCER_TOKEN',
);

export const HOME_STORAGE_KEY_TOKEN = new InjectionToken(
  'HOME_STORAGE_KEY_TOKEN',
);

export const HOME_STORAGE_KEYS_TO_SAVE_TOKEN = new InjectionToken(
  'HOME_STORAGE_KEYS_TO_SAVE_TOKEN',
);
